import { render } from "./SignUpDetail.vue?vue&type=template&id=1646a110"
import script from "./SignUpDetail.vue?vue&type=script&lang=js"
export * from "./SignUpDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__